





















































import { Vozidlo } from '@/modules/kartoteka/vozidlo';
import { Pracovnik } from '@/modules/administrace/pracovnik';
import { listFactory } from '@/main/pages';

import { store } from './store/list';
import { NAME } from './constants';
import { types } from './store/types';


export default listFactory(NAME, store).extend({
	components: {
		VozidloSelect: Vozidlo.components.Select,
		PracovnikSelect: Pracovnik.components.Select,
	},
	computed: {
		mutationsMappers() {
			return {
				vozidlo: `${this.storeUri}/${types.mutations.VOZIDLA_PUJCOVNY_VOZIDLO_SELECT_MAPPER}`,
				pracovnikUzivatel: `${this.storeUri}/${types.mutations.VOZIDLA_PUJCOVNY_PRAC_UZIVATEL_SELECT_MAPPER}`,
				pracovnikTechnik: `${this.storeUri}/${types.mutations.VOZIDLA_PUJCOVNY_PRAC_TECHNIK_SELECT_MAPPER}`,
				vstupPracovnik: `${this.storeUri}/${types.mutations.VOZIDLA_PUJCOVNY_VSTUP_PRAC_SELECT_MAPPER}`,
			};
		},
	},
});
